<template>
    <div>
        <div class="hero">
            <div class="hero-body">
                <div class="container">
                    <h1 class="title">
                        Mailing
                        &rarr;
                        <span v-if="$route.name.indexOf('request') !== -1">
                            Catalog Requests
                        </span>
                        <span v-if="$route.name.indexOf('subscription') !== -1">
                            Newsletter Subscriptions
                        </span>
                        <span v-if="$route.name.indexOf('email-list') !== -1">
                            Email List
                        </span>
                    </h1>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="tabs">
                <ul>
                    <router-link tag="li" :to="{ name: 'requests' }" exact><a>Catalog Requests</a></router-link>
                    <router-link tag="li" :to="{ name: 'subscriptions' }" exact><a>Newsletter Subscriptions</a></router-link>
                    <router-link tag="li" :to="{ name: 'email-list' }" exact><a>Email List</a></router-link>
                </ul>
            </div>
            <div>
                <transition mode="out-in" name="fade">
                    <router-view></router-view>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Mailing',
    };
</script>



// WEBPACK FOOTER //
// Mailing.vue?10de675a